// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0441d282","239":"1a004b7c","455":"3d0e6f5f","488":"e573570d"}[chunkId] + ".chunk.js";
};